import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useQuery } from 'urql';
import { deleteContinueWatchingListContents } from '../../actions/continueWatching';
import {
    continueWatchingActiveSelector,
    continueWatchingItemsSelector,
} from '../../reducers/continueWatching.js';
import { PlaceHolder } from '../../ui-components/PlaceHolder/PlaceHolder';
import ContentList from '../../ui-components/ContentList/ContentList';
import QUERY from './ContinueWatching.graphql';
import { createContentoHistory } from '../../utils/continueWatchingUtils';
import env from 'app/env';
import {
    StyledPlaceHolderContainer,
    StyledPlaceHolderHeaderWrapper,
    StyledPlaceHolderHeader,
} from './ContinueWatchingList.styles';
import { accessVersionChoiceSelector } from 'app/reducers/videoPage';

const ContinueWatchingPlaceholder = () => (
    <StyledPlaceHolderContainer>
        <StyledPlaceHolderHeaderWrapper>
            <StyledPlaceHolderHeader>Fortsätt titta</StyledPlaceHolderHeader>
        </StyledPlaceHolderHeaderWrapper>
        <PlaceHolder nrOfItems={4} />
    </StyledPlaceHolderContainer>
);

let displayServerPlaceHolders = true;

const ContinueWatchingListContainer = ({
    continueWatchingItems,
    continueWatchingIsActive,
    deleteContinueWatchingListItems,
    currentAccessibilityChoice,
    onItemClick,
}) => {
    const [showPlaceholder, setShowPlaceholder] = useState(displayServerPlaceHolders); // Always show placeholder server side

    let history = createContentoHistory(continueWatchingItems);

    useEffect(() => {
        setShowPlaceholder(false);
        // After initial server render we no longer need server placeholders
        // Rendering them will cause browsers, without history, to shift in scroll position
        displayServerPlaceHolders = false;
    }, []);

    if (showPlaceholder) {
        return <ContinueWatchingPlaceholder key={'placeholder'} />;
    }

    if (!continueWatchingIsActive || !history || !history.length) {
        return null;
    }

    return (
        <ContinueWatchingList
            history={history}
            continueWatchingIsActive={continueWatchingIsActive}
            deleteContinueWatchingListItems={deleteContinueWatchingListItems}
            onItemClick={onItemClick}
            continueWatchingItems={continueWatchingItems}
            currentAccessibilityChoice={currentAccessibilityChoice}
        />
    );
};

const ContinueWatchingList = ({
    continueWatchingIsActive,
    deleteContinueWatchingListItems,
    currentAccessibilityChoice,
    continueWatchingItems,
    history,
    onItemClick,
}) => {
    const [result] = useQuery({
        query: QUERY,
        variables: {
            history: history,
            includeFullOppetArkiv: env.FLAG_ENABLE_ALL_OA,
        },
        context: React.useMemo(
            () => ({
                preferGetMethod: false,
            }),
            []
        ),
    });

    const { data, fetching, error } = result;

    if (fetching) {
        return <ContinueWatchingPlaceholder key={'placeholder'} />;
    }

    if (!data || error) {
        return null;
    }

    const headerText = data.keepWatching.name;

    return (
        <ContentList
            id="pers"
            key="continue-watch-list"
            items={data.keepWatching.items}
            headerText={headerText}
            expandable={false}
            onDeleteItems={deleteContinueWatchingListItems}
            regTestSpec="continue-watching"
            continueWatchingIsActive={continueWatchingIsActive}
            continueWatchingItems={continueWatchingItems}
            deletableItems
            onItemClick={onItemClick}
            autoPlay
        />
    );
};

const mapStateToProps = (state) => {
    return {
        currentAccessibilityChoice: accessVersionChoiceSelector(state),
        continueWatchingItems: continueWatchingItemsSelector(state),
        continueWatchingIsActive: continueWatchingActiveSelector(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteContinueWatchingListItems: (deletedItems) =>
            dispatch(deleteContinueWatchingListContents(deletedItems)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContinueWatchingListContainer);
